module.exports = __webpack_public_path__ + "static/media/my-bets.e0a2bc9d.svg";